var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { memo } from "react";
var SvgLanes = function SvgLanes(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 80,
    viewBox: "0 0 96 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10275_136739)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.43567 39.917H12.2201",
    stroke: "#A9B2BD",
    strokeWidth: 1.85582,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1229 39.917H32.8734",
    stroke: "#A9B2BD",
    strokeWidth: 1.85582,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7761 39.917H53.5266",
    stroke: "#A9B2BD",
    strokeWidth: 1.85582,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4293 39.917H74.2137",
    stroke: "#A9B2BD",
    strokeWidth: 1.85582,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.1165 39.917H94.8673",
    stroke: "#A9B2BD",
    strokeWidth: 1.85582,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.43567 26.8525H94.8667",
    stroke: "#A9B2BD",
    strokeWidth: 1.85582,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.43567 52.9824H94.8667",
    stroke: "#A9B2BD",
    strokeWidth: 1.85582,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.43567 79.0791H94.8667",
    stroke: "#697684",
    strokeWidth: 1.85582,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.43542 0.72168H94.8666",
    stroke: "#697684",
    strokeWidth: 1.85582,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.43567 66.0469H12.2201",
    stroke: "#697684",
    strokeWidth: 1.85582,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1229 66.0469H32.8734",
    stroke: "#697684",
    strokeWidth: 1.85582,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7761 66.0469H53.5266",
    stroke: "#697684",
    strokeWidth: 1.85582,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4293 66.0469H74.2137",
    stroke: "#697684",
    strokeWidth: 1.85582,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.1165 66.0469H94.8673",
    stroke: "#697684",
    strokeWidth: 1.85582,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.43567 13.7871H12.2201",
    stroke: "#697684",
    strokeWidth: 1.85582,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1229 13.7871H32.8734",
    stroke: "#697684",
    strokeWidth: 1.85582,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7761 13.7871H53.5266",
    stroke: "#697684",
    strokeWidth: 1.85582,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4293 13.7871H74.2137",
    stroke: "#697684",
    strokeWidth: 1.85582,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.1165 13.7871H94.8673",
    stroke: "#697684",
    strokeWidth: 1.85582,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1083 38.5083L48.4243 21.9212C48.2269 21.725 47.9076 21.7256 47.7109 21.9225L31.0873 38.5697C30.8907 38.7666 30.8912 39.0854 31.0886 39.2816L47.7722 55.8686C47.9696 56.0648 48.289 56.0642 48.4857 55.8673L65.1095 39.2201C65.3059 39.0232 65.3052 38.7045 65.1083 38.5083Z",
    fill: "#A9B2BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0894 42.8165C47.9128 42.8169 47.7379 42.782 47.575 42.714C47.4121 42.6459 47.2646 42.546 47.141 42.4202C47.0174 42.2944 46.9202 42.1452 46.8553 41.9813C46.7903 41.8175 46.7589 41.6423 46.7627 41.4662L46.7418 29.8891C46.7412 29.5387 46.8801 29.2024 47.128 28.9541C47.3759 28.7059 47.7124 28.5661 48.0637 28.5654C48.4148 28.5648 48.7519 28.7034 49.0007 28.9508C49.2494 29.1981 49.3896 29.5339 49.3902 29.8843L49.4111 41.4614C49.4156 41.6375 49.3848 41.8128 49.3204 41.9768C49.2561 42.1409 49.1595 42.2905 49.0363 42.4167C48.9132 42.543 48.766 42.6434 48.6033 42.7121C48.4407 42.7807 48.2659 42.8163 48.0894 42.8165Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.101 49.4858C47.9244 49.4861 47.7495 49.4513 47.5866 49.3832C47.4237 49.3151 47.2762 49.2153 47.1526 49.0894C47.0289 48.9636 46.9318 48.8144 46.8669 48.6506C46.8019 48.4867 46.7705 48.3116 46.7743 48.1354L46.7703 45.9018C46.7696 45.5514 46.9085 45.2151 47.1564 44.9668C47.4043 44.7186 47.7409 44.5788 48.0921 44.5781C48.4433 44.5775 48.7803 44.7161 49.0291 44.9634C49.2779 45.2108 49.418 45.5466 49.4187 45.897L49.4227 48.1306C49.4272 48.3068 49.3964 48.4821 49.332 48.6461C49.2677 48.8102 49.171 48.9598 49.0479 49.086C48.9247 49.2123 48.7776 49.3127 48.6149 49.3814C48.4523 49.45 48.2775 49.4855 48.101 49.4858Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10275_136739"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 95,
    height: 79.8,
    fill: "white",
    transform: "translate(0.5)"
  })))));
};
var Memo = /*#__PURE__*/memo(SvgLanes);
export { Memo as ReactComponent };
export default __webpack_public_path__ + "assets/illustrations/Lanes.e673031fe9252af76b398ab5f719310f.svg";